import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=ca53b802&scoped=true&"
import script from "./TicketForm.vue?vue&type=script&lang=js&"
export * from "./TicketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca53b802",
  null
  
)

export default component.exports